var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bo-import-logs"},_vm._l((_vm.all),function(l,k){return _c('p',{key:k,class:`text-${l.type}`},[_vm._v("\n    "+_vm._s(l.text)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }